import { Component } from '@angular/core';

@Component({
  selector: 'app-department-systempflege',
  templateUrl: 'department-systempflege.component.html',
  styleUrls: ['department-systempflege.component.scss'],
  standalone: false,
})
export class DepartmentSystempflegeComponent {
  constructor() {}
}
